import React, { useMemo } from 'react'
import useStore from '@/store'
import classNames from 'classnames'
import type { Props } from './types'
import type {
  Location as TLocation,
  Resident as TResident,
} from '@/store/types'
import Label from '@/components/label'
import styles from './style.module.scss'
import Location from '../locations/location'

const LinkPoint: React.FC<Props> = ({
  label,
  type,
  position,
  labelPlacement,
  residents,
  clickHandler,
}) => {
  const activeCategoryFilter = useStore((state) => state.activeCategoryFilter)
  const sounds = useStore((state) => state.sounds)
  const image = useMemo(
    () =>
      require(`@/assets/images/${
        type === 'Primary'
          ? 'button-green_1200.png'
          : type === 'Secondary'
          ? 'button-yellow_1200.png'
          : type === 'Tertiary' || type === 'Non_Interactive'
          ? 'button-blue_1200.png'
          : type === 'Switzerland'
          ? 'button-switzerland_1200.png'
          : null
      }`),
    [type]
  )
  const filteredResidents = useMemo(
    () =>
      residents
        ?.filter((r) =>
          Object.values(activeCategoryFilter).includes(
            r.attributes.Category.data.attributes.Slug
          )
        )
        .reduce((acc, cur) => {
          return acc.filter(
            (item) =>
              item.attributes.Category.data.attributes.Slug ===
              cur.attributes.Category.data.attributes.Slug
          ).length < 4 && !acc.find((item) => item.id === cur.id)
            ? acc.concat(cur)
            : acc
        }, [] as (TLocation | TResident)[]),
    // eslint-disable-next-line
    [activeCategoryFilter]
  )
  const classes = classNames(styles['link-point'], [styles[`type--${type}`]], {
    [styles['is-mirrorred']]: position.Mirrored,
  })

  function onClick() {
    if (type !== 'Non_Interactive') sounds?.click2?.play()
    if (clickHandler) clickHandler()
  }

  return (
    <div
      className={classes}
      style={{
        top: `${position.Y}%`,
        left: `${position.X}%`,
      }}
    >
      <Label
        text={label}
        placement={labelPlacement}
        hidden={false}
        type={type === 'Switzerland' ? 'link-point-switzerland' : 'link-point'}
        clickHandler={() => onClick()}
      />
      <button
        className={styles.button}
        onClick={() => onClick()}
        style={{
          backgroundImage: `url(${image})`,
        }}
      />
      {filteredResidents?.length ? (
        <div className={styles.residents}>
          {filteredResidents.map((r) => (
            <Location
              key={r.id}
              data={r}
              isActive={false}
              isFiltered={false}
              isResident={true}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default React.memo(LinkPoint)
